// extracted by mini-css-extract-plugin
export default {"root":"PNehtnMZQ5xFOioDBeTq","briefcase":"ejPfULPEotsOty4bVv64","text":"uuLqQLxJFU2n1mXxjJV1"};